import styled from "styled-components";

export const ActivitiesContainerStyled = styled.div`
  .content {
    padding: 32px 20px 20px;
    .breadcrumb_layout {
      margin-bottom: 30px;
    }
    .fav_row {
      display: flex;
      flex-wrap: wrap;
      column-gap: 18px;
      .activities_item {
        margin-bottom: 26px;
        flex-basis: calc(50% - 9px);
        overflow: hidden;
        &:last-child {
          margin-bottom: 0px;
        }
      }
    }
  }

  @media (max-width: ${({ theme }) => theme.SCREENS.SURFACE_DUO}) {
    .content {
      .breadcrumb_layout {
        display: none;
      }
      .fav_row {
        .activities_item {
          flex-basis: calc(50% - 9px);
        }
      }
    }
  }
`;
